import { inject, Injectable, signal } from '@angular/core';
import { dsApi, httpApi, webDtos } from '@vectronic/openApi-admin';
import { getRandomColor } from '@vectronic/ui';
import { latestBuild } from '@vectronic/util';
import { finalize, forkJoin, map, Observable, switchMap } from 'rxjs';
export interface MapPositionsList extends webDtos.MapPositionsList {
  speciesId?: string;
}

@Injectable({ providedIn: 'root' })
export class AdminMapPositionsService {
  private gpsPositionApi = inject(httpApi.GPSPositions);
  private collarApi = inject(dsApi.Collars);

  mapPositions = signal<MapPositionsList[]>([]);
  loading = signal(false);

  fetchMapPositions(request: webDtos.PositionRequest) {
    this.loading.set(true);
    this.getMapPositions(request)
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe((mapPositions) => this.mapPositions.set(mapPositions));
  }

  getMapPositions(request: webDtos.PositionRequest): Observable<MapPositionsList[]> {
    return this.gpsPositionApi.getData(request).pipe(
      map((positions) => {
        const groupedPositions = new Map<number, webDtos.MapPositionsList>();
        positions.forEach((position) => {
          const existingCollar = groupedPositions.get(position.idDevice);
          if (existingCollar) existingCollar.positions.push(position);
          else {
            groupedPositions.set(position.idDevice, {
              id: position.idDevice,
              name: `Collar ${position.idDevice}`,
              positions: [position],
            });
          }
        });
        return Array.from(groupedPositions.values());
      }),
      switchMap((mapPositions) =>
        forkJoin(
          mapPositions.map((mapPositionsList) =>
            this.collarApi.getById(mapPositionsList.id).pipe(
              map((collar) => ({
                ...mapPositionsList,
                color: collar.color ?? getRandomColor(),
                speciesId: latestBuild(collar)?.animalSpeciesId,
              })),
            ),
          ),
        ),
      ),
    );
  }
}
